import Bugsnag from '@bugsnag/js';
import axios from 'axios';

export default {
    data() {
        return {
            apiKey: process.env.MIX_GOOGLE_KEY,
            geocoder: null,
        };
    },
    mounted() {
        const geocoderScript = document.createElement('script');
        geocoderScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`);
        document.head.append(geocoderScript);
    },
    methods: {
        buildAddress(entity) {
            let output = '';

            if (entity.street_number && entity.route) {
                output = `${entity.street_number} ${entity.route}`;
            }
            if (entity.locality) {
                output = `${output}, ${entity.locality}`;
            }
            if (entity.administrative_area_level_1) {
                output = `${output}, ${entity.administrative_area_level_1}`;
            }
            if (entity.postal_code) {
                output = `${output} ${entity.postal_code}`;
            }
            if (entity.country_code) {
                output = `${output}, ${entity.country_code}`;
            }

            return output.trim();
        },
        geocodeAddress(entity) {
            const ADDRESS_COMPONENTS = {
                    street_number: 'short_name',
                    route: 'short_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    country: 'short_name',
                    postal_code: 'short_name',
                },
                buildComponents = () => {
                    const output = {};
                    output.country = entity.country_code;

                    if (entity.postal_code) {
                        output.postalCode = entity.postal_code?.toString();
                    }

                    return output;
                };

            this.geocoder = new google.maps.Geocoder();

            return new Promise((resolve, reject) => {
                this.geocoder.geocode(
                    {
                        address: this.buildAddress(entity),
                        componentRestrictions: buildComponents(),
                    },
                    (results, status) => {
                        if (status === 'OK') {
                            if (results[0].partial_match !== true) {
                                for (const component of results[0].address_components) {
                                    const addressType = component.types[0];
                                    if (ADDRESS_COMPONENTS[addressType] && entity[addressType === 'country' ? 'country_code' : addressType] !== undefined) {
                                        entity[addressType === 'country' ? 'country_code' : addressType] = component[ADDRESS_COMPONENTS[addressType]];
                                    }
                                }
                            } else {
                                Bugsnag.notify(new Error('Partial match returned from address geocode.'), (event) => {
                                    event.severity = 'error';
                                    event.addMetadata('contextData', {
                                        entity,
                                        results,
                                        status,
                                    });
                                });
                            }

                            const { lat, lng } = results[0].geometry.location;
                            entity.lat = lat();
                            entity.lng = lng();

                            axios.post(route('api.timezone'), { lat: lat(), lng: lng() }).then(
                                (response) => {
                                    if (response.data.status === 'OK') {
                                        entity.timezone = response.data.timeZoneId;
                                        resolve(entity);
                                    } else {
                                        reject(new Error(response.data.status));
                                    }
                                },
                                (error) => {
                                    reject(new Error(error.response.data.status));
                                },
                            );
                        } else {
                            reject(new Error(status));
                        }
                    },
                );
            });
        },
    },
};
